export default "__VITE_ASSET__DZP8ge$p__"